"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.number.constructor");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _CurrentContext = _interopRequireDefault(require("../context/CurrentContext"));

var _StyledSettingsComponents = require("./StyledSettingsComponents");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    background: rgb(225, 225, 225);\n    border-width: 0px;\n    padding: 3px 5px;\n    color: darkslategray;\n    border-radius: 3px;\n    outline: none;\n    font-size: 11px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledInput = _styledComponents.default.input(_templateObject(), function (_ref) {
  var width = _ref.width;
  return width || '50px';
});

var Input =
/*#__PURE__*/
function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChange = function (e, onChangeProp, current) {
      var _this$props = _this.props,
          prop = _this$props.prop,
          isNumber = _this$props.isNumber,
          format = _this$props.format,
          onChange = _this$props.onChange;
      var value = e.target.value;
      var val = value ? isNumber ? Number(value.replace(/[^.0-9]/gim, '')) : value : null;
      var formated = format ? format(val, current) : val;
      onChangeProp(prop, formated);
      onChange && onChange(formated);
    };

    _this.getValue = function (current) {
      var _this$props2 = _this.props,
          prop = _this$props2.prop,
          parse = _this$props2.parse;
      var value = (0, _ramda.isNil)(current[prop]) ? '' : current[prop];
      return parse ? parse(value, current) : value;
    };

    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          small = _this$props3.small,
          width = _this$props3.width;
      return _react.default.createElement(_CurrentContext.default.Consumer, null, function (_ref2) {
        var current = _ref2.current,
            onChangeProp = _ref2.onChangeProp;
        return _react.default.createElement("div", null, _react.default.createElement(StyledInput, {
          type: "text",
          width: width,
          value: _this2.getValue(current),
          onChange: function onChange(e) {
            return _this2.onChange(e, onChangeProp, current);
          }
        }), small && _react.default.createElement(_StyledSettingsComponents.Small, null, small));
      });
    }
  }]);

  return Input;
}(_react.Component);

exports.default = Input;
Input.propTypes = {
  small: _propTypes.default.string,
  isNumber: _propTypes.default.bool,
  prop: _propTypes.default.string,
  parse: _propTypes.default.func,
  format: _propTypes.default.func,
  onChange: _propTypes.default.func
};